import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import Loader from 'react-loaders'

const LoadingModalTransparent = (props) => {
    return (
        <Modal body={ 'padding-right: 0 !important' } isOpen={props.isOpen} className={'modal-fullscreen shadow-none'}>
            <ModalBody className={'modal-content shadow-none'}>
                <Loader type="line-scale-party" color='white' />
            </ModalBody>
        </Modal>
    );
}

export default LoadingModalTransparent;